import React from 'react';
import styled from 'styled-components';
import { H3 } from '../../../../assets/styles/Typography';
import { palette } from '../../../../assets/styles/Palette';
import { TabContent5Item } from '../../../../assets/styles/BusinessAnalysisStyle';

const typeOptions = [
  { value: "grade1", label: "1학년" },
  { value: "grade2", label: "2학년" },
  { value: "grade3", label: "3학년" },
  { value: "teachers_office", label: "교무실" },
  { value: "gym", label: "체육관" },
  { value: "cafeteria", label: "식당" },
  { value: "nurse_office", label: "양호실" },
  { value: "music_room", label: "음악실" },
  { value: "science_lab", label: "과학실" },
  { value: "art_room", label: "미술실" },
  { value: "auditorium", label: "강당" },
  { value: "library", label: "도서관" },
];

const OrganismTypeSelector = ({ selectedTypes, onSelectionChange }) => {
  return (
    <div className="content" style={{ marginTop: "40px" }}>
      <TabContent5Item required>
        <H3
          color="gray800"
          style={{ textAlign: "left", marginBottom: "16px" }}
        >
          콘텐츠 표시 위치를 선택해주세요 (다중 선택 가능)
        </H3>
        <CheckboxRadioGroup>
          {typeOptions.map((option) => (
            <CheckboxRadioCard
              key={option.label}
              checked={selectedTypes.includes(option.label)}
              onClick={() => onSelectionChange(option.label)}
            >
              <CheckboxRadioCardContent>
                <CheckboxRadioCardTitle>{option.label}</CheckboxRadioCardTitle>
                <CustomCheckbox checked={selectedTypes.includes(option.label)} />
              </CheckboxRadioCardContent>
              <HiddenRadioInput
                type="checkbox"
                name="typeSelection"
                value={option.label}
                checked={selectedTypes.includes(option.label)}
                readOnly
              />
            </CheckboxRadioCard>
          ))}
        </CheckboxRadioGroup>
      </TabContent5Item>
    </div>
  );
};

export default OrganismTypeSelector;

const CheckboxRadioGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  width: 100%;
`;

const CheckboxRadioCard = styled.div`
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#E0E4EB")};
  background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.02)" : "#fff")};
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  // min-width: 200px;

  &:hover {
    border-color: ${({ checked }) => (checked ? "#226FFF" : "#BCC4D0")};
    background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA")};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

const CheckboxRadioCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const CheckboxRadioCardTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${palette.gray900};
`;

const CustomCheckbox = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#C8D1E1")};
  border-radius: 4px;
  position: relative;
  background: ${({ checked }) => (checked ? "#226FFF" : "#fff")};
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &::after {
    content: "";
    display: block;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    opacity: ${({ checked }) => (checked ? 1 : 0)};
  }
`;

const HiddenRadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;